import { CommonUtility } from "../../Services/CommonUtility";
import { getNoteHistory } from "../../shared/components/Notes&History/service/NoteAPI";
import { CustomerNote } from "../model/CustomerNoteModel";
import { updateNote, getAllNotesList, createNote } from "../services/CustomerAPI";
import ValidateCustomerNote from "./CustomerNoteValidate";

class CustomerNoteService
{
    updateNote = async (note : CustomerNote) => {
        let noteCopy = CommonUtility.deepCloneObject(note);
        this.processNote(noteCopy);
        var status= await updateNote(noteCopy)
        //customerData.customerNotes = customerData.customerNotes.sort((a,b) =>  b.changedDate.localeCompare(a.changedDate));
        return status;
    }

    getNotes = async (customerId : string) => {
        var noteData =  await getAllNotesList(customerId)
        return noteData;
    }

    getNoteHistory = async (noteId : string) => {
        var noteData =  await getNoteHistory(noteId)
        return noteData;
    }

    createNote =  async (note : CustomerNote) => {
        let noteCopy = CommonUtility.deepCloneObject(note);
        this.processNote(noteCopy);
        var noteData =  await createNote(noteCopy)
        return noteData;
    }

    processNote = (note : CustomerNote) : any => {
        note.noteDate = CommonUtility.datetimeToDateOnly(note.noteDate);
    }

    validateNote = (customerNote : CustomerNote) : any => {
        let validator =  new ValidateCustomerNote();
        let validationErrors = {};
        
        let descrError = validator.validateDescription(customerNote.note);
        if (descrError.isValid == false) {
            validationErrors['note'] = descrError;
        }

        let noteDateError =  validator.validateNoteDate(customerNote.noteDate);
        if (noteDateError.isValid == false) {
            validationErrors['noteDate'] = noteDateError;
        }

        return validationErrors;
    }
}
export default CustomerNoteService;